import React from 'react'
import Link from 'gatsby-link'
import { Group, Button } from 'rebass'
import Heading from '../components/Heading'
import styled from 'styled-components'
import ButtonLink from './ButtonLink'

const StyledLinkActive = styled(Link)`
  color: white;
  text-decoration: none;
  font-weight: bold;
`

const Section = ({ active, name, title, to }) =>
  active === name ? (
    <Button children={<StyledLinkActive to={to}>{title}</StyledLinkActive>} />
  ) : (
    <ButtonLink to={to} title={title} />
  )

const Toc = ({ active }) => (
  <div>
    <Heading fontSize={7}>
      SSR React with Symfony
      <span style={{ fontSize: '12px' }}>
        for the Strong of Spirit <span role="img">⚔</span>
      </span>
      Workshop
    </Heading>
    <Group>
      <Section active={active} name="kick off" title="Kick off" to="/" />
      <Section active={active} name="webpack" title="Webpack" to="/webpack" />
      <Section
        active={active}
        name="encore"
        title="Webpack Encore"
        to="/encore"
      />
      <Section active={active} name="react" title="React Bundle" to="/react" />
      <Section active={active} name="routing" title="Routing" to="/routing" />
      <Section active={active} name="meta" title="Meta tags" to="/meta" />
      <Section active={active} name="speed" title="Speed" to="/speed" />
    </Group>
  </div>
)

export default Toc



// WEBPACK FOOTER //
// ./src/components/Toc.js